import React, {useState} from 'react'
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { getConfirmationIcon } from "../../../utils/utils"
import axios from 'axios'
import { CircularProgress } from '@material-ui/core';

const theme = createMuiTheme({
    palette:{
        primary: {
            main:"#0b1f82"
        },
        secondary: {
            main: "#FF0000"
        },
    }
  });

function InputContent (props){
    let {handleRefreshPage} = props
    let {setLockType}       = props
    let {onClose}           = props
    let {lockType}          = props
    let {alert}             = props

    let search_data         = alert.triggers[0].trigger_group.search_data
    let lockLinkKey         = search_data[lockType]

    const [pendingState, setPendingState] = useState(false)
    const [status, setStatus] = useState(null)
    const [observationBox, setObservationBox] = useState();
    const [reason, setReason] = useState();

    const handleBackClick = () => {
        setLockType(null)
    }

    const handleReturn = () => {
        handleRefreshPage()
        onClose()
    }

    const handleObservationBoxChange = (event) => {
        if (event.target.value.length === 0){
            setObservationBox(null)
        }
        else{
            setObservationBox(event.target.value)
        }
    };

    const handleReasonInputChange = (event) => {
        if (event.target.value.length === 0){
            setReason(null)
        }
        else{
            setReason(event.target.value)
        }
    };

    const onSubmit = () => {
        let payload = {}
        if (observationBox){
            payload['observation'] = observationBox
        }
        if(reason){
            payload['lock_reason'] = reason
        }
        payload['lock_source'] = 'manual_alert_analysis'
        payload['alert_key']   = alert.alert_key
        payload['locked_event_type'] = props.lockedEventType
        payload['lock_type'] = lockType
        payload['lock_link_key'] = lockLinkKey
        setPendingState(true)
        axios.post('/dash/alerts/lock', payload).then(response => {
            setPendingState(false)   
            setStatus({success: true, message: "Requisição processada com sucesso"})
        }).catch(error => {
            setPendingState(false)
            setStatus({success: false, message: "Não foi possível processar sua requisição"})
        });
      }


    
    if (pendingState){
        return(
            <div style={{display:"flex", flexGrow:"1"}}>
                <CircularProgress style={{margin:"auto"}}/>
            </div>
        )
    }
    if (status != null) {
        return(
            <div style={{ display:"flex", flexDirection:"column", flexGrow:"1"}}>
                <div style={{margin:"auto"}}>
                    {getConfirmationIcon(status.success)}
                </div>
                <div style={{margin:"auto"}}>
                    {status.message}
                </div>
                <div
                    onClick={handleReturn} 
                    className={["button","standard", "normalText", "normalMediumSize"].join(" ")} 
                    style={{margin:"auto auto 20px auto", width:"auto"}}
                >
                    VOLTAR À PÁGINA INICIAL
                </div>
            </div>
        )
    }

    return (
        <div style={{ display:"flex", flexDirection:"column", flexGrow:"1"}}>
            <div style={{display: "flex",justifyContent: "center",flexDirection: "column",margin: "0 auto 10px auto",width: "60%"}}>
            <ThemeProvider theme={theme}>
                <TextField  
                    style={{marginTop: "10px"}}    
                    fullWidth
                    multiline
                    variant="outlined"
                    label={"Razão"}
                    color="primary"
                    onChange={handleReasonInputChange}
                />
                <TextField  
                    style={{marginTop: "10px"}}    
                    fullWidth
                    multiline
                    variant="outlined"
                    rows="5"
                    label={"Observações"}
                    color="primary"
                    onChange={handleObservationBoxChange}
                />
            </ThemeProvider>               
            </div>
            <div style={{display:"flex", flexDirection:"row", justifyContent: "center", margin:"auto 0px 20px 0px"}}>
                <div
                    className={["button","standard", "normalText", "normalMediumSize"].join(" ")} 
                    onClick={onSubmit} 
                    style={{width:"40%"}}
                >
                    Finalizar
                </div>
                <div
                    className={["button","cancel"].join(" ")} 
                    onClick={handleBackClick} 
                    style={{width:"40%"}}
                >
                    Retornar
                </div>
            </div>
        </div>
    )

}

export default InputContent